





































































import { Component, Vue, Prop } from 'nuxt-property-decorator'
import { mdiChevronRight, mdiMenu, mdiChevronDown } from '@mdi/js'
import LazyHydrate from 'vue-lazy-hydration'
import { ILinkItem } from '~/assets/interfaces/navigation'
import { ISubCategory } from '~/assets/interfaces/categories'

@Component({
  components: {
    LazyHydrate,
    ComponentIcon: () => import('~/components/icon/icon.vue'),
    ComponentImage: () => import('~/components/images/image.vue'),
  },
})
export default class ComponentMobileCategoryPath extends Vue {
  @Prop({ type: Array, default: () => [] }) private tree!: ILinkItem[]
  @Prop({ type: Array, default: () => [] })
  private subCategories!: ISubCategory[]

  @Prop({ type: String, default: 'type-1' }) private type!: string

  private isOpen = false
  private mdiChevronRight = mdiChevronRight
  private mdiMenu = mdiMenu
  private mdiChevronDown = mdiChevronDown
  private mounted(): void {
    this.$emit('loaded')
  }
}
